import React, { useMemo, useEffect, useState } from "react";
import Table from "../../../../Components/Table/index";
import axios from "axios";
import { API_CONSTANTS } from "../../../../API_CONSTANTS";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import style from "../../../../Style/corporate.module.css";
import { Button, Checkbox } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import Switch from "@mui/material/Switch";
import CancelIcon from "@mui/icons-material/Cancel";
import LoadingButton from "@mui/lab/LoadingButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer, toast } from "react-toastify";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ErrorIcon from "@mui/icons-material/Error";
import AlertMessage from "../../../../Components/AlertMessage";
import CustomToggleButton from "../../../../Components/toggleButton/toggelbutton";
import { getData } from "../../../addData/addDataSlice";
import { faTimesCircle } from "@fortawesome/fontawesome-free-solid";
import Toast from "../../../../Components/Toast/Toast";

// Styling
const styles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
};
const partnerStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: 3,
  maxHeight: "80vh",
  overflowY: "auto",
  overflowX: "hidden",
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
    borderRadius: "12px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#bbb",
    borderRadius: "8px",
    border: "2px solid transparent",
    backgroundClip: "content-box",
  },
  scrollbarWidth: "thin",
  scrollbarColor: "#bbb transparent",
};

export default function CorporatePlans() {
  const [open, setOpen] = useState(false);
  const [addPlanLoading, setAddPlanLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [isDiscountCorporate, setIsDiscountCorporate] = useState(false);
  const [addNewPlan, setAddNewPlan] = useState({
    planName: "",
    noOfCalls: "",
    employeeCalls: "",
    noOfEmployee: "",
    pricePerEmployee: "",
    planStatus: "inActive",
    planDuration: "",
    totalPrice: "",
    selectedSpecializations: [],
    appointment_prices: {},
  });
  const {
    planName,
    noOfCalls,
    employeeCalls,
    noOfEmployee,
    pricePerEmployee,
    planStatus,
    planDuration,
    totalPrice,
    selectedSpecializations,
    appointment_prices,
  } = addNewPlan;
  const [page, setPage] = useState(0);
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState("");
  const [plansList, setPlansList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const fetchIdRef = React.useRef(0);
  const dispatch = useDispatch();
  const [ToastMessage, setToastMessage] = useState('')
  const [showToast, setShowToast] = useState('')
  const [ToastIcon, setToastIcon] = useState(faTimesCircle)
  const [iconColor, setIconColor] = useState('')
  const handleToast = (message, icon, iconColor, className) => {
      setToastIcon(icon)
      setToastMessage(message)
      setShowToast(`show ${className}`)
      setIconColor(iconColor)
      setTimeout(() => setShowToast(''), 2900)
  }

  const { loading1, value } = useSelector((state) => state.getDataReducer);

  useEffect(() => {
    dispatch(getData());
  }, [dispatch]);

  const handleSpecializationChange = (event) => {
    const selected = event.target.value;
    // Preserve existing prices for unchanged specializations
    const newAppointmentPrices = {};
    selected.forEach((specialization) => {
      if (appointment_prices[specialization]) {
        newAppointmentPrices[specialization] =
          appointment_prices[specialization];
      } else {
        newAppointmentPrices[specialization] = "";
      }
    });
    setAddNewPlan((prev) => ({
      ...prev,
      selectedSpecializations: selected,
      appointment_prices: newAppointmentPrices,
    }));
  };

  const handlePriceChange = (specialization, value) => {
    // Validate input: allow only numbers or empty string
    if (value === "" || /^\d+$/.test(value)) {
      setAddNewPlan((prev) => ({
        ...prev,
        appointment_prices: {
          ...prev.appointment_prices,
          [specialization]: value,
        },
      }));
    }
  };

  const handleDeleteSpecialization = (specializationToDelete) => {
    const updatedSpecializations = selectedSpecializations.filter(
      (spec) => spec !== specializationToDelete
    );
    const newAppointmentPrices = { ...appointment_prices };
    delete newAppointmentPrices[specializationToDelete];
    setAddNewPlan((prev) => ({
      ...prev,
      selectedSpecializations: updatedSpecializations,
      appointment_prices: newAppointmentPrices,
    }));
  };

  const getDataFromFields = (e) => {
    setAddNewPlan((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setAddNewPlan({
      planName: "",
      noOfCalls: "",
      employeeCalls: "",
      noOfEmployee: "",
      pricePerEmployee: "",
      planStatus: "Active",
      planDuration: "",
      totalPrice: "",
      selectedSpecializations: [],
      appointment_prices: {},
    });
    setOpen(false);
    setEdit(false);
    setIsDiscountCorporate(false);
  };

  const fetchData = React.useCallback(
    ({ pageSize, pageIndex }) => {
      const fetchId = lastEvaluatedKey;
      if (fetchId === fetchIdRef.current) {
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        setPlansList(plansList.slice(startRow, endRow));
        setPageCount(Math.ceil(plansList.length / pageSize));
      }
    },
    [plansList, lastEvaluatedKey]
  );

  const userList = () => {
    axios
      .get(
        `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan?corporateplan=true`,
        {
          headers: API_CONSTANTS.headers(),
        }
      )
      .then((res) => {
        setPlansList(res.data.response.Items[0].list);
        setIsLoading(true);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          window.location.reload();
          window.localStorage.clear();
        }
        setIsLoading(true);
        setPlansList([]);
      });
  };

  const handleLoadMoreData = () => {
    axios
      .post(
        `${API_CONSTANTS.BASEURL_4}admin/corporates?last=${lastEvaluatedKey}`,
        {},
        {
          headers: API_CONSTANTS.headers(),
        }
      )
      .then((response) => {
        setLastEvaluatedKey(response.data.response.LastEvaluatedKey);
        const patientListNextPage = response.data.response.Items;
        setPlansList([...plansList, ...patientListNextPage]);
        setPage(page + 1);
      })
      .then(() => setLoading(true));
  };

  const handleAddPartner = (e, id) => {
    setAddPlanLoading(true);

    // Common validation
    if (
      !planName ||
      !noOfCalls ||
      !employeeCalls ||
      !noOfEmployee ||
      !pricePerEmployee ||
      !planDuration ||
      !totalPrice
    ) {
      toast("Please fill all required fields", { type: "error" });
      setAddPlanLoading(false);
      return;
    }

    // Base data structure
    let payload = {
      planName,
      noOfCalls: parseInt(noOfCalls),
      employeeCalls: parseInt(employeeCalls),
      noOfEmployee: parseInt(noOfEmployee),
      pricePerEmployee: parseInt(pricePerEmployee),
      planStatus: planStatus || "Active",
      planDuration: parseInt(planDuration),
      totalPrice: parseInt(totalPrice),
    };

    // API configuration based on plan type and operation
    let config = {};
    if (isDiscountCorporate) {
      // Discount Corporate Plan
      if (!selectedSpecializations.length) {
        toast("Please select at least one specialization", { type: "error" });
        setAddPlanLoading(false);
        return;
      }
      // Validate that all specializations have prices
      const missingPrices = selectedSpecializations.filter(
        (spec) => !appointment_prices[spec] || appointment_prices[spec] === ""
      );
      if (missingPrices.length > 0) {
        toast("Please enter prices for all selected specializations", {
          type: "error",
        });
        setAddPlanLoading(false);
        return;
      }
      for (const element of selectedSpecializations) {
        console.log(element)
        console.log(appointment_prices[element])
        if (appointment_prices[element] > 100) {
          toast("Percentage should be less than 100", {
            type: "error",
          });
          setAddPlanLoading(false);  
          return; // This will exit the parent function
        }
      }
      payload = {
        ...payload,
        corporate_plan_type: "Discount",
        appointment_prices,
      };

      config = edit
        ? {
            method: "patch",
            url: `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan/${addNewPlan?.pId}?corporateplan=true`,
            data: payload,
            headers: API_CONSTANTS.headers(),
          }
        : {
            method: "post",
            url: `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan?corporateplan=true`,
            data: payload,
            headers: API_CONSTANTS.headers(),
          };
    } else {
      // Corporate Plan
      config = edit
        ? {
            method: "patch",
            url: `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan/${addNewPlan?.pId}?corporateplan=true`,
            data: payload,
            headers: API_CONSTANTS.headers(),
          }
        : {
            method: "post",
            url: `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan?corporateplan=true`,
            data: payload,
            headers: API_CONSTANTS.headers(),
          };
    }

    // Log payload for debugging
    console.log("Sending payload:", payload);

    // Execute API call
    axios(config)
      .then((res) => {
        if (edit) {
          // Update plansList for edit operation
          setPlansList((prev) =>
            prev.map((item) =>
              item.pId === addNewPlan.pId
                ? {
                    ...item,
                    ...payload,
                    appointment_prices: isDiscountCorporate
                      ? addNewPlan.appointment_prices
                      : undefined,
                  }
                : item
            )
          );
        } else {
          // Update plansList for create operation
          setPlansList((prev) => [
            ...prev,
            {
              pId: res.data.response.pId || Date.now().toString(),
              ...payload,
              appointment_prices: isDiscountCorporate
                ? appointment_prices
                : undefined,
            },
          ]);
        }

        setAddPlanLoading(false);
        toast(
          res.data.response.message ||
            `Plan ${edit ? "updated" : "added"} successfully`,
          {
            type: "success",
          }
        );

        // Reset form
        setAddNewPlan({
          planName: "",
          noOfCalls: "",
          employeeCalls: "",
          noOfEmployee: "",
          pricePerEmployee: "",
          planStatus: "Active",
          planDuration: "",
          totalPrice: "",
          selectedSpecializations: [],
          appointment_prices: {},
        });
        setOpen(false);
        setEdit(false);
        setIsDiscountCorporate(false);
      })
      .catch((err) => {
        setAddPlanLoading(false);
        console.error("API Error Details:", err.response);
        toast(
          err.response?.data?.response?.message ||
            "Something went wrong, please try again",
          { type: "error" }
        );
      });
  };

  const handleEdit = (data) => {
    setOpen(true);
    setEdit(true);
    const selectedSpecializations = data.appointment_prices
      ? Object.keys(data.appointment_prices)
      : [];
    setAddNewPlan({
      planName: data.planName,
      noOfCalls: data.noOfCalls.toString(),
      employeeCalls: data.employeeCalls.toString(),
      noOfEmployee: data.noOfEmployee.toString(),
      pricePerEmployee: data.pricePerEmployee.toString(),
      planStatus: data.planStatus,
      planDuration: data.planDuration.toString(),
      totalPrice: data.totalPrice.toString(),
      selectedSpecializations,
      appointment_prices: data.appointment_prices || {},
      pId: data.pId,
    });
    setIsDiscountCorporate(data.corporate_plan_type === "Discount");
  };

  const columns = useMemo(
    () => [
      {
        Header: "No",
        accessor: (row, index) => index + 1,
      },
      {
        Header: "Plan Name",
        accessor: "planName",
      },
      {
        Header: "No. of Employees",
        accessor: "noOfEmployee",
      },
      {
        Header: "Calls/Employee",
        accessor: "employeeCalls",
      },
      {
        Header: "Duration",
        accessor: "planDuration",
      },
      {
        Header: "Price/Employee",
        accessor: "pricePerEmployee",
      },
      {
        Header: "Total Price",
        accessor: "totalPrice",
      },
      {
        Header: "Plan Type",
        accessor: "corporate_plan_type",
      },
      {
        Header: "Status",
        accessor: (item) => (
          <ActivatedDeactivated
            planStatus={item.planStatus}
            plan={item}
            setPlansList={setPlansList}
          />
        ),
      },
      {
        Header: "Action",
        accessor: (item) => (
          <ActionBtn
            item={item}
            onEdit={handleEdit}
            setPlansList={setPlansList}
          />
        ),
      },
    ],
    []
  );

  const is_SessionExpire = () => {
    window.localStorage.clear();
    window.location.reload();
  };

  useEffect(() => {
    if (plansList.length < 1) {
      userList();
    }
  }, []);

  if (error) {
    return (
      <AlertMessage
        errorMessage={
          error.message === "Request failed with status code 404"
            ? "This record does not exist"
            : error.message === "Request failed with status code 401"
            ? is_SessionExpire()
            : error.message
        }
      />
    );
  } else {
    return (
      <>
        <section className={style.corporatePageSection}>
          <Button
            variant="contained"
            className={style.addPartnerBtn}
            onClick={handleOpen}
          >
            <AddIcon />
            Add New Plan
          </Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={partnerStyles}>
              <div className={style.addPartnerModalContainer}>
                <Button
                  className={style.closeBtnPartnerModal}
                  onClick={handleClose}
                >
                  <CloseIcon />
                </Button>
                <CustomToggleButton
                  isDiscountCorporate={isDiscountCorporate}
                  setIsDiscountCorporate={setIsDiscountCorporate}
                />
                {isDiscountCorporate ? (
                  <div className={style.addPartnerModal}>
                    <TextField
                      id="standard-basic"
                      label="Discount Plan Name"
                      variant="standard"
                      name="planName"
                      onChange={getDataFromFields}
                      required
                      value={planName}
                    />
                    <TextField
                      id="standard-basic"
                      label="No. of Employees"
                      variant="standard"
                      name="noOfEmployee"
                      onChange={getDataFromFields}
                      required
                      type="number"
                      value={noOfEmployee}
                    />
                    <div>
                      <FormControl variant="standard">
                        <InputLabel id="demo-simple-select-standard-label">
                          Total Calls
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={noOfCalls}
                          label="Total Calls"
                          name="noOfCalls"
                          onChange={getDataFromFields}
                        >
                          <MenuItem value="" selected disabled>
                            --Select--
                          </MenuItem>
                          <MenuItem value={100}>100 Calls</MenuItem>
                          <MenuItem value={500}>500 Calls</MenuItem>
                          <MenuItem value={1000}>1000 Calls </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      <FormControl variant="standard">
                        <InputLabel id="demo-simple-select-standard-label">
                          No of Calls per employee
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={employeeCalls}
                          label="No of Calls per employee"
                          name="employeeCalls"
                          onChange={getDataFromFields}
                        >
                          <MenuItem value="" selected disabled>
                            --Select--
                          </MenuItem>
                          <MenuItem value={3}>3 Calls</MenuItem>
                          <MenuItem value={5}>5 Calls</MenuItem>
                          <MenuItem value={7}>7 Calls</MenuItem>
                          <MenuItem value={10}>10 Calls</MenuItem>
                          <MenuItem value={12}>12 Calls</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      <FormControl variant="standard">
                        <InputLabel id="demo-simple-select-standard-label">
                          Duration
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={planDuration}
                          label="Duration"
                          name="planDuration"
                          onChange={getDataFromFields}
                        >
                          <MenuItem value="" selected disabled>
                            --Select--
                          </MenuItem>
                          <MenuItem value={1}>1 Month</MenuItem>
                          <MenuItem value={2}>2 Month</MenuItem>
                          <MenuItem value={3}>3 Month</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <TextField
                      id="standard-basic"
                      label="Price per Employee"
                      variant="standard"
                      name="pricePerEmployee"
                      onChange={getDataFromFields}
                      required
                      type="number"
                      value={pricePerEmployee}
                    />
                    <TextField
                      id="standard-basic"
                      label="Total Price"
                      variant="standard"
                      name="totalPrice"
                      onChange={getDataFromFields}
                      required
                      type="number"
                      value={totalPrice}
                    />
                    <div>
                      {loading1 ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          style={{ color: "#24AAA4" }}
                        />
                      ) : value?.Specializations?.length > 0 ? (
                        <>
                          <FormControl variant="standard" fullWidth>
                            <InputLabel id="specialization-select-label">
                              Select Specializations
                            </InputLabel>
                            <Select
                              labelId="specialization-select-label"
                              id="specialization-select"
                              multiple
                              value={selectedSpecializations}
                              onChange={handleSpecializationChange}
                              renderValue={(selected) =>
                                selected[selected.length - 1] || ""
                              }
                            >
                              {value.Specializations.map((item) => (
                                <MenuItem key={item.Id} value={item.Id}>
                                  <Checkbox
                                    checked={
                                      selectedSpecializations.indexOf(item.Id) >
                                      -1
                                    }
                                  />
                                  {item.Id}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {selectedSpecializations.length > 0 && (
                            <div>
                              <h6
                                style={{
                                  marginTop: "16px",
                                }}
                              >
                                Specialization Prices
                              </h6>
                              {selectedSpecializations.map((spec) => (
                                <div
                                  key={spec}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "8px",
                                    gap: "8px",
                                  }}
                                >
                                  <TextField
                                    label={`${spec} Discount Percentage (1-100)`}
                                    variant="standard"
                                    value={appointment_prices[spec] || ""}
                                    onChange={(e) =>
                                      handlePriceChange(spec, e.target.value)
                                    }
                                    type="text"
                                    style={{ flex: 1 }}
                                    inputProps={{
                                      pattern: "[0-9]*",
                                      maxLength: 3,
                                      title: "Please enter numbers only",
                                    }}
                                  />
                                  <Button
                                    color="error"
                                    onClick={() =>
                                      handleDeleteSpecialization(spec)
                                    }
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      ) : (
                        <p>No specializations available.</p>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className={style.addPartnerModal}>
                    <TextField
                      id="standard-basic"
                      label="Plan Name"
                      variant="standard"
                      name="planName"
                      onChange={getDataFromFields}
                      required
                      value={planName}
                    />
                    <TextField
                      id="standard-basic"
                      label="No. of Employees"
                      variant="standard"
                      name="noOfEmployee"
                      onChange={getDataFromFields}
                      required
                      type="number"
                      value={noOfEmployee}
                    />
                    <div>
                      <FormControl variant="standard">
                        <InputLabel id="demo-simple-select-standard-label">
                          Total Calls
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={noOfCalls}
                          label="Total Calls"
                          name="noOfCalls"
                          onChange={getDataFromFields}
                        >
                          <MenuItem value="" selected disabled>
                            --Select--
                          </MenuItem>
                          <MenuItem value={100}>100 Calls</MenuItem>
                          <MenuItem value={500}>500 Calls</MenuItem>
                          <MenuItem value={1000}>1000 Calls </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      <FormControl variant="standard">
                        <InputLabel id="demo-simple-select-standard-label">
                          No of Calls per employee
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={employeeCalls}
                          label="No of Calls per employee"
                          name="employeeCalls"
                          onChange={getDataFromFields}
                        >
                          <MenuItem value="" selected disabled>
                            --Select--
                          </MenuItem>
                          <MenuItem value={3}>3 Calls</MenuItem>
                          <MenuItem value={5}>5 Calls</MenuItem>
                          <MenuItem value={7}>7 Calls</MenuItem>
                          <MenuItem value={10}>10 Calls</MenuItem>
                          <MenuItem value={12}>12 Calls</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      <FormControl variant="standard">
                        <InputLabel id="demo-simple-select-standard-label">
                          Duration
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={planDuration}
                          label="Duration"
                          name="planDuration"
                          onChange={getDataFromFields}
                        >
                          <MenuItem value="" selected disabled>
                            --Select--
                          </MenuItem>
                          <MenuItem value={1}>1 Month</MenuItem>
                          <MenuItem value={2}>2 Month</MenuItem>
                          <MenuItem value={3}>3 Month</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <TextField
                      id="standard-basic"
                      label="Price per Employee"
                      variant="standard"
                      name="pricePerEmployee"
                      onChange={getDataFromFields}
                      required
                      type="number"
                      value={pricePerEmployee}
                    />
                    <TextField
                      id="standard-basic"
                      label="Total Price"
                      variant="standard"
                      name="totalPrice"
                      onChange={getDataFromFields}
                      required
                      type="number"
                      value={totalPrice}
                    />
                  </div>
                )}
                <div className={style.actionBtnModal + " mt-4 ps-3"}>
                  <LoadingButton
                    className={style.actionBtn}
                    variant="contained"
                    loading={addPlanLoading}
                    onClick={handleAddPartner}
                    disabled={
                      planName &&
                      noOfCalls &&
                      employeeCalls &&
                      noOfEmployee &&
                      pricePerEmployee &&
                      planStatus &&
                      planDuration &&
                      totalPrice &&
                      (!isDiscountCorporate ||
                        (selectedSpecializations.length > 0 &&
                          selectedSpecializations.every(
                            (spec) =>
                              appointment_prices[spec] &&
                              appointment_prices[spec] !== ""
                          )))
                        ? false
                        : true
                    }
                  >
                    {edit ? "Save Plan" : "Add Plan"}
                  </LoadingButton>
                  <Button
                    onClick={handleClose}
                    color="error"
                    className={style.actionBtn}
                  >
                    Discard
                  </Button>
                </div>
              </div>
            </Box>
          </Modal>
          <div className="row rounded bg-white m-4">
            <h3
              style={{ fontSize: "16px", fontWeight: "500", padding: "18px" }}
            >
              All Plans
              {!isLoading && (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{ color: "#24AAA4" }}
                />
              )}
            </h3>
            <Table
              pageNumber={page}
              columns={columns}
              data={plansList}
              routingLink={``}
              pageCount={pageCount}
              fetchData={fetchData}
              loadMoreList={handleLoadMoreData}
              lastEvaluatedKey={lastEvaluatedKey}
              loading={loading}
              recordDownload={true}
              setLoading={setLoading}
            />
          </div>
        </section>
        <ToastContainer />
        <Toast
          cName={showToast}
          icon={ToastIcon}
          color={iconColor}
          text={ToastMessage}
      />
      </>
    );
  }
}

const ActivatedDeactivated = ({ setPlansList, planStatus, plan }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(
    planStatus === "Active" ? true : false
  );

  const handleClose = () => {
    setLoading(false);
    setOpen(false);
  };

  const handleChange = (e) => {
    setOpen(true);
  };

  const handleClick = () => {
    setLoading(true);
    axios
      .patch(
        `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan/${plan.pId}?corporateplan=true`,
        {
          planName: plan.planName,
          noOfCalls: parseInt(plan.noOfCalls),
          employeeCalls: parseInt(plan.employeeCalls),
          noOfEmployee: parseInt(plan.noOfEmployee),
          pricePerEmployee: parseInt(plan.pricePerEmployee),
          totalPrice: parseInt(plan.totalPrice),
          planDuration: parseInt(plan.planDuration),
          planStatus: plan.planStatus === "Active" ? "inActive" : "Active",
          corporate_plan_type: plan.corporate_plan_type,
          appointment_prices: plan.appointment_prices,
        },
        { headers: API_CONSTANTS.headers() }
      )
      .then((res) => {
        setPlansList((prev) =>
          prev.map((item) => {
            if (item.pId === plan.pId) {
              return {
                ...item,
                planStatus:
                  plan.planStatus === "Active" ? "inActive" : "Active",
              };
            } else return item;
          })
        );
        setLoading(false);
        setChecked(!checked);
        setOpen(false);
        toast(`Status changed successfully`, {
          type: "success",
        });
      })
      .catch((erro) => {
        setLoading(false);
        toast(`Something goes wrong try again`, {
          type: "error",
        });
      });
  };

  return (
    <div>
      <Switch checked={checked} onChange={handleChange} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles}>
          <div className={style.plansModalContainer}>
            {checked ? (
              <CancelIcon color="error" style={{ fontSize: "2rem" }} />
            ) : (
              <CheckCircleIcon color="success" style={{ fontSize: "2rem" }} />
            )}
            <p
              className={style.modalTextError}
              style={{
                color: checked ? " #af1300" : "#1E1E1E",
              }}
            >
              {checked ? "Deactivate Plan" : "Activate Plan"}
            </p>
            <p className={style.modalText}>
              {checked
                ? `Are you sure you want to Deactivate ${plan.planName}`
                : `Are you sure you want to Activate ${plan.planName}.`}
            </p>
            <div className={style.actionBtnModal}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleClose}
                className={style.actionBtn}
              >
                Close
              </Button>
              <LoadingButton
                variant="contained"
                color={checked ? "error" : "success"}
                size="small"
                onClick={handleClick}
                className={style.actionBtn}
                loading={loading}
              >
                {checked ? "Deactivate" : "Activate"}
              </LoadingButton>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

const ActionBtn = ({ onEdit, item, setPlansList }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setLoading(false);
    setOpen(false);
  };

  const handleClick = () => {
    setLoading(true);
    axios
      .delete(
        `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan/${item.pId}?corporateplan=true`,
        { headers: API_CONSTANTS.headers() }
      )
      .then((res) => {
        setPlansList((prev) => prev.filter((plan) => plan.pId !== item.pId));
        setLoading(false);
        setOpen(false);
        toast(`Plan deleted successfully`, {
          type: "success",
        });
      })
      .catch((erro) => {
        setLoading(false);
        toast(`Something goes wrong try again`, {
          type: "error",
        });
      });
  };

  return (
    <div>
      <div>
        <Button onClick={() => onEdit(item)} color="secondary">
          <EditIcon />
        </Button>
        <Button color="error" onClick={handleOpen}>
          <DeleteIcon />
        </Button>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles}>
          <div className={style.plansModalContainer}>
            <ErrorIcon color="error" style={{ fontSize: "2rem" }} />
            <p
              className={style.modalTextError}
              style={{
                color: " #af1300",
              }}
            >
              {"Delete Plan"}
            </p>
            <p className={style.modalText}>
              Are you sure you want to Delete this plan
            </p>
            <div className={style.actionBtnModal}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleClose}
                className={style.actionBtn}
              >
                Close
              </Button>
              <LoadingButton
                variant="contained"
                color={"error"}
                size="small"
                onClick={handleClick}
                className={style.actionBtn}
                loading={loading}
              >
                {"Delete"}
              </LoadingButton>
            </div>
          </div>
        </Box>
      </Modal>

    </div>
  );
};
